import { IStatisticsGrid, DriverStatisticsType } from '@sky-it-livedata/livedata-sports-design-system';
import { DriverStatisticsQuery, statsOrder } from './types';
import { ErrorName, WidgetError } from '../../utils/errors';
import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';


export const isValidDriverStatisticsObject = (obj: DriverStatisticsQuery): boolean => {
  return Boolean(obj?.data?.getDriverStatsWidget && !isEmptyObject(obj.data.getDriverStatsWidget));
}

const transformer = (obj: DriverStatisticsQuery): IStatisticsGrid => {
  if (isValidDriverStatisticsObject(obj)) {
    const { driverId, statistics } = obj.data.getDriverStatsWidget;
    const subtitle = `STAGIONE ${statistics.customSeasonName}`;

    const filteredStats = statistics.stats
      .filter((stat) => statsOrder.includes(stat.type))
      .sort((a, b) => statsOrder.indexOf(a.type) - statsOrder.indexOf(b.type));

    // mapped the value to match the frontend
    const mappedStats = filteredStats.map((stat) => ({
      type: 'stat' as 'stat',
      id: stat.type as DriverStatisticsType,
      value: stat.value,
    }));

    return {
      subtitle,
      variant: 'DRIVER',
      statistics: {
        driverId,
        items: mappedStats,
      },
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in DriverStatisticsQuery object',
      data: obj
    });
  }
};

export default transformer;